import { render, staticRenderFns } from "./v-demo.vue?vue&type=template&id=e11f8ad6&"
import script from "./v-demo.vue?vue&type=script&lang=ts&"
export * from "./v-demo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e11f8ad6')) {
      api.createRecord('e11f8ad6', component.options)
    } else {
      api.reload('e11f8ad6', component.options)
    }
    module.hot.accept("./v-demo.vue?vue&type=template&id=e11f8ad6&", function () {
      api.rerender('e11f8ad6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/v-demo.vue"
export default component.exports